export default __webpack_public_path__ + "static/media/Suffix-Logo.73142c9b.png";